package mobile.icard.ICardRoomDatabase

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import kotlin.collections.Collection

public class ContactImageLinksQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getLinkForContactID(contactID: String?, mapper: (link: String?) -> T):
      Query<T> = GetLinkForContactIDQuery(contactID) { cursor ->
    mapper(
      cursor.getString(0)
    )
  }

  public fun getLinkForContactID(contactID: String?): Query<GetLinkForContactID> =
      getLinkForContactID(contactID) { link ->
    GetLinkForContactID(
      link
    )
  }

  public fun <T : Any> getAllContactLinks(mapper: (
    wallet_id: Long,
    contact_id: String?,
    link: String?,
    name: String?,
    last_ts: Long,
  ) -> T): Query<T> = Query(1_215_419_908, arrayOf("contact_image_links"), driver,
      "ContactImageLinks.sq", "getAllContactLinks", """
  |SELECT
  |    wallet_id,
  |    contact_id,
  |    link,
  |    name,
  |    last_ts
  |FROM contact_image_links
  """.trimMargin()) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)!!
    )
  }

  public fun getAllContactLinks(): Query<GetAllContactLinks> = getAllContactLinks { wallet_id,
      contact_id, link, name, last_ts ->
    GetAllContactLinks(
      wallet_id,
      contact_id,
      link,
      name,
      last_ts
    )
  }

  public fun <T : Any> getContactNameByWalletID(walletID: Long, mapper: (name: String?) -> T):
      Query<T> = GetContactNameByWalletIDQuery(walletID) { cursor ->
    mapper(
      cursor.getString(0)
    )
  }

  public fun getContactNameByWalletID(walletID: Long): Query<GetContactNameByWalletID> =
      getContactNameByWalletID(walletID) { name ->
    GetContactNameByWalletID(
      name
    )
  }

  public fun writeContactData(
    walletID: Long?,
    contactID: String?,
    link: String?,
    name: String?,
    name_search: String?,
    timestamp: Long,
  ) {
    driver.execute(-1_519_687_925, """
        |INSERT OR REPLACE INTO contact_image_links
        |    (wallet_id, contact_id, link, name, name_search, last_ts)
        |VALUES
        |    (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindLong(0, walletID)
          bindString(1, contactID)
          bindString(2, link)
          bindString(3, name)
          bindString(4, name_search)
          bindLong(5, timestamp)
        }
    notifyQueries(-1_519_687_925) { emit ->
      emit("contact_image_links")
    }
  }

  public fun deleteUnusedContacts(items: Collection<Long>) {
    val itemsIndexes = createArguments(count = items.size)
    driver.execute(null, """
        |UPDATE contact_image_links
        |SET name = NULL, name_search = NULL, contact_id = NULL
        |WHERE wallet_id NOT IN $itemsIndexes
        """.trimMargin(), items.size) {
          items.forEachIndexed { index, items_ ->
            bindLong(index, items_)
          }
        }
    notifyQueries(1_660_997_460) { emit ->
      emit("contact_image_links")
    }
  }

  private inner class GetLinkForContactIDQuery<out T : Any>(
    public val contactID: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("contact_image_links", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("contact_image_links", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT
    |    link
    |FROM contact_image_links
    |WHERE contact_id ${ if (contactID == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, contactID)
    }

    override fun toString(): String = "ContactImageLinks.sq:getLinkForContactID"
  }

  private inner class GetContactNameByWalletIDQuery<out T : Any>(
    public val walletID: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("contact_image_links", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("contact_image_links", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_845_480_512, """
    |SELECT name
    |FROM contact_image_links
    |WHERE wallet_id = ?
    """.trimMargin(), mapper, 1) {
      bindLong(0, walletID)
    }

    override fun toString(): String = "ContactImageLinks.sq:getContactNameByWalletID"
  }
}
